var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"priority",class:_vm.priorityClass,on:{"click":function($event){$event.preventDefault();return _vm.changePriority($event)}}},[_c('p',[_vm._v(_vm._s(_vm.priorityLetter))])])}
var staticRenderFns = []

export { render, staticRenderFns }